import React from "react";
import {observer} from "mobx-react-lite";
import EditField from "../../molecules/editField/editField";
import Select from "react-select";
import {EventBookingDeadlineDetails} from "../../../stores/domainStore/pages/models/eventBookingDeadlineDetails";
import "./eventBookingDeadlineEdit.sass";
import {useTranslation} from "react-i18next";
import {IconSource} from "../../../shared/enums/iconSource";
import {EventPaidType} from "../../../shared/enums/eventPaidType";
import Banner from "../../atoms/banner/banner";
import {addDays} from "date-fns";

export interface IEventBookingDeadlineEditProps {
  isPreReleasedEventReleased: boolean | undefined;
  value: EventBookingDeadlineDetails;
  eventPaidType?: string;
  eventStartDate?: Date | null;
  onChange?: (weeksChanged: boolean) => void;
}

// TODO JB we should use pluralisation from the translation library here

const EventBookingDeadlineEdit: React.FC<IEventBookingDeadlineEditProps> = ({
  isPreReleasedEventReleased,
  value,
  eventPaidType,
  eventStartDate,
  onChange
}) => {
  const {t} = useTranslation(["event"]);
  const isDeadLineInvalid = !value.isDeadlineValid;

  const isWeeksDisabled = eventStartDate
    ? addDays(eventStartDate, -7) < new Date()
    : false;

  return (
    <div className="booking-deadline">
      <EditField
        label={t("event:labels.booking.deadline")}
        helpText={t("event:labels.booking.deadlineHelpText")}
        validationMessage={t("event:errors.booking.deadline")}
        showValidationMessage={isDeadLineInvalid}
        isRequired={value.validate != null}
      >
        <div className="w-100">
          {eventPaidType === EventPaidType.fixed &&
            Number(value.weeks.selectedItem?.value ?? 0) < 1 &&
            Number(value.days.selectedItem?.value ?? 0) < 5 && (
              <Banner
                text={t("event:labels.booking.minBookingDeadLineForPrice")}
                icon={IconSource.info}
              />
            )}
        </div>
        <div>
          <div className="deadline-controls">
            <span data-testid="bookingDeadline-weeks">
              <Select
                aria-label="week-select"
                value={value.weeks.selectedItem}
                options={value.weeks.items}
                onChange={(newValue) => {
                  value.weeks.setSelectedItem(newValue!.value);
                }}
                className={`single-select ${isDeadLineInvalid && "invalid"} ${
                  (isWeeksDisabled || isPreReleasedEventReleased) &&
                  "is-disabled"
                }
                    `}
                classNamePrefix="select"
                placeholder={t("event:placeholders.week")}
                inputId="deadline-edit-weeks"
                onInputChange={() => onChange?.(true)}
                isDisabled={isWeeksDisabled || isPreReleasedEventReleased}
              />
            </span>
            <span data-testid="bookingDeadline-days">
              <Select
                aria-label="day-select"
                value={value.days.selectedItem}
                options={value.days.items}
                onChange={(newValue) => {
                  value.days.setSelectedItem(newValue!.value);
                }}
                className={`single-select ${isDeadLineInvalid && "invalid"} ${
                  isPreReleasedEventReleased && "is-disabled"
                }`}
                classNamePrefix="select"
                placeholder={t("event:placeholders.day")}
                inputId="deadline-edit-days"
                isDisabled={isPreReleasedEventReleased}
                onInputChange={() => onChange?.(false)}
              />
            </span>
            <span data-testid="bookingDeadline-hours">
              <Select
                aria-label="hour-select"
                value={value.hours.selectedItem}
                options={value.hours.items}
                onChange={(newValue) => {
                  value.hours.setSelectedItem(newValue!.value);
                }}
                className={`single-select ${isDeadLineInvalid && "invalid"} ${
                  isPreReleasedEventReleased && "is-disabled"
                }`}
                classNamePrefix="select"
                placeholder={t("event:placeholders.hour")}
                inputId="deadline-edit-hours"
                isDisabled={isPreReleasedEventReleased}
                onInputChange={() => onChange?.(false)}
              />
            </span>
          </div>
        </div>
      </EditField>
    </div>
  );
};
export default observer(EventBookingDeadlineEdit);
